import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import ReactDOM from "react-dom/client";
import MainApp from "./MainApp";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import { ORG_SHORT_NAME } from "./util/appInfo";

const root = ReactDOM.createRoot(
  document.getElementById("app-site") as HTMLElement
);
root.render(<MainApp />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (ORG_SHORT_NAME?.toLowerCase() === "idb") {
  document.documentElement.style.setProperty(
    "--app-font-family",
    "Aptos, sans-serif"
  );
}
